<template>
  <div>
    <loading :active.sync="loading"
             :loader="'dots'"
             :color="'#58f0ac'"
             :width="128"
             :background-color="'#000'"
             :opacity="0.75"
             :can-cancel="false"
             :is-full-page="true"></loading>
    <div class="row">
      <div class="col-12">
        <card type="chart">
          <template slot="header">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-2  col-xl-2" :class="'text-left'">
                <h2 class="card-title mt-lg-3 mt-xl-1">Statistika</h2>
              </div>
              <div
                class="col-12  col-md-4 col-lg-10  col-xl-10 d-flex  flex-column flex-lg-row  flex-xl-row justify-content-lg-between justify-content-xl-end">
                <base-button size="sm" type="info" class="btn-custom" @click="rangeBtnClicked('1d')">1 Dan</base-button>
                <base-button size="sm" type="info" class="btn-custom" @click="rangeBtnClicked('7d')">7 Dana
                </base-button>
                <base-button size="sm" type="info" class="btn-custom" @click="rangeBtnClicked('1m')">1 Mesec
                </base-button>
                <base-button size="sm" type="info" class="btn-custom" @click="rangeBtnClicked('3m')">3 Meseca
                </base-button>
                <div class="my-2 my-xl-0">
                  <label for="startDateTime" style="margin-left:10px; margin-bottom:2px;">Početni datum:</label>
                  <datetime v-model="startDateTime" input-id="startDateTime" type="datetime"
                            input-class="datetime-input" title="Početni datum" format="dd-MM-yyyy HH:mm"
                            :min-datetime="minDatetime" :max-datetime="maxDatetime">
                  </datetime>
                </div>
                <div class="mb-2 my-xl-0">
                  <label for="endDateTime" style="margin-left:10px; margin-bottom:2px;">Krajnji datum:</label>
                  <datetime v-model="endDateTime" input-id="endDateTime" type="datetime" input-class="datetime-input"
                            title="Krajnji datum" format="dd-MM-yyyy HH:mm" :min-datetime="minDatetime"
                            :max-datetime="maxDatetime">
                  </datetime>
                </div>
              </div>
            </div>
          </template>
          <div class="chart-area">
            <highcharts class="stock" ref="chart" :options="chart.stockOptions"></highcharts>
          </div>
        </card>
      </div>
    </div>
    <div class="row mt-2 justify-content-center">
      <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-5">
        <card type="chart">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
              <div class="chart-area">
                <highcharts :options="pieOptions"></highcharts>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 align-self-center">
              <div style="font-size:18px; font-weight: 900; text-align: left;">
                <p>Isporučena energija: {{parseFloat(powerSum).toFixed(2)}} kW</p>
                <p>Srednja unutrašnja: {{unutrasnjaTempSred}} °C</p>
                <p>Srednja spoljašnja: {{spoljTempSred}} °C</p>
                <p>Srednja aku. 1: {{baferTempSred}} °C</p>
                <p>Vreme rada: {{radniSati}}</p>
                <p>Vreme mirovanja: {{satiMirovanja}}</p>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import UserServices from "@/services/UserServices";
  import { Chart } from "highcharts-vue";
  import Highcharts from "highcharts";
  import boost from "highcharts/modules/boost";
  boost(Highcharts);



  export default {
    components: {
      highcharts: Chart
    },
    data() {
      return {
        loading: false,
        startDateTime: null,
        endDateTime: null,
        minDatetime: null,
        maxDatetime: null,
        powerSum: 0,
        unutrasnjaTempSred: 0,
        spoljTempSred: 0,
        baferTempSred: 0,
        radniSati: 0,
        satiMirovanja: 0,
        chart: {
          stockOptions: {
            title: {
              text: ''
            },
            xAxis: {
              type: 'datetime',
              labels: {
                style: {
                  color: "#a0a0a0",
                  fontSize: '16px'
                }
              }
            },
            yAxis: {
              title: {
                text: null
              },
              labels: {
                style: {
                  color: "#a0a0a0",
                  fontSize: '16px'
                }
              }
            },
            tooltip: {
              shared: true,
              crosshairs: true,
              headerFormat: '<span style="font-size: 18px;"><b>{point.key}</b></span><br/>',
              pointFormat: '<span style="color:{point.color};">●</span> {series.name}: <b>{point.y}</b><br/>',
              style: {
                fontSize: '18'
              }
            },
            plotOptions: {
              series: {
                lineWidth: 3
              }
            },
            chart: {
              backgroundColor: "transparent"
            },
            legend: {
              itemStyle: {
                color: "#a0a0a0",
                fontSize: '20px',
                textDecoration: "none"
              },
              itemHiddenStyle: {
                color: "#15161e",
                fontSize: '20px',
                textDecoration: "line-through"
              }
            },
            credits: {
              enabled: false
            },
			colors: ['#2f7ed8', '#fe019a', '#8bbc21', '#d4af37', '#1aadce', '#ee82ee', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
            series: []
          }
        },
        pieOptions: {
          chart: {
            backgroundColor: "transparent",
            type: "pie"
          },
          title: {
            text: "Vreme rada",
            style: { "color": "#FFF", "fontSize": "18px" }
          },
          tooltip: {
            pointFormat: '<b>{point.percentage:.1f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                color: "#fff"
              }
            }
          },
          credits: {
            enabled: false
          },
          series: [
            {
              data: [
              ],
              colors: ['#ed4040', '#7cb5ec', '#434348']
            }
          ]
        }
      }
    },
    methods: {
      async getData() {
        this.loading = true;
        let response = await UserServices.getDeviceStats({
          startDateTime: this.startDateTime,
          endDateTime: this.endDateTime
        });
        let seriesOptions = []

        seriesOptions[0] = {
          name: "Akumulacija 1",
          data: response.data.data.chart["A1M"],
          tooltip: {
            valueSuffix: " C"
          },
          marker: {
            enabled: false
          }
        };
        seriesOptions[1] = {
          name: "Akumulacija 2",
          data: response.data.data.chart["A2M"],
          tooltip: {
            valueSuffix: " C"
          },
          marker: {
            enabled: false
          }
        };

        seriesOptions[2] = {
          name: "Ulaz primara",
          data: response.data.data.chart["UPT"],
          tooltip: {
            valueSuffix: " C"
          },
          marker: {
            enabled: false
          }
        };

        seriesOptions[3] = {
          name: "Izlaz primara",
          data: response.data.data.chart["IPT"],
          tooltip: {
            valueSuffix: " C"
          },
          marker: {
            enabled: false
          }
        };

        seriesOptions[4] = {
          name: "Ulaz sekundara",
          data: response.data.data.chart["UST"],
          tooltip: {
            valueSuffix: " C"
          },
          marker: {
            enabled: false
          }
        };

        seriesOptions[5] = {
          name: "Izlaz sekundara",
          data: response.data.data.chart["IST"],
          tooltip: {
            valueSuffix: " C"
          },
          marker: {
            enabled: false
          }
        };

        seriesOptions[6] = {
          name: "Energija primara",
          data: response.data.data.chart["SPR"],
          tooltip: {
            valueSuffix: " kW/h"
          },
          marker: {
            enabled: false
          }
        };

        seriesOptions[7] = {
          name: "Energija sekundara",
          data: response.data.data.chart["SSE"],
          tooltip: {
            valueSuffix: " kW/h"
          },
          marker: {
            enabled: false
          }
        };

        seriesOptions[8] = {
          name: "Unutra",
          data: response.data.data.chart["UNM"],
          tooltip: {
            valueSuffix: " C"
          },
          marker: {
            enabled: false
          }
        };

        seriesOptions[9] = {
          name: "Spolja",
          data: response.data.data.chart["SPM"],
          tooltip: {
            valueSuffix: " C"
          },
          marker: {
            enabled: false
          }
        };

        this.chart.stockOptions.series = seriesOptions;

        this.pieOptions.series[0].data = [
          {
            name: "Rad",
              y: response.data.data.stats["activePercent"]
          },
          {
            name: "Mirovanje",
              y: response.data.data.stats["idlePercent"]
          },
          {
            name: "Nepoznato",
              y: response.data.data.stats["unknownPercent"]
          }
        ]

        this.powerSum = response.data.data.stats["powerSum"]
        this.unutrasnjaTempSred = response.data.data.stats["unutrasnjaTempSred"]
        this.spoljTempSred = response.data.data.stats["spoljTempSred"]
        this.baferTempSred = response.data.data.stats["baferTempSred"]
        this.radniSati = response.data.data.stats["radniSati"]
        this.satiMirovanja = response.data.data.stats["satiMirovanja"]

        this.loading = false;
      },
      rangeBtnClicked(val) {
        let now = new Date();
        let start;
        switch (val) {
          case "1d":
            start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, now.getHours(), now.getMinutes())
            break;
          case "7d":
            start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7, now.getHours(), now.getMinutes())
            break;
          case "1m":
            start = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate(), now.getHours(), now.getMinutes())
            break;
          case "3m":
            start = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate(), now.getHours(), now.getMinutes())
            break;
          default:
            start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, now.getHours(), now.getMinutes())
        }
        this.startDateTime = start.toISOString();
        this.getData()
      }

    },
    async mounted() {
      this.i18n = this.$i18n;

      let now = new Date();
      this.endDateTime = now.toISOString();
      let start = new Date(now.getFullYear(), now.getMonth(), now.getDate() -1, now.getHours(), now.getMinutes())
      this.startDateTime = start.toISOString();

      let maxDT = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate())
      this.maxDatetime = maxDT.toISOString();

      let minDT = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate(), now.getHours(), now.getMinutes())
      this.minDatetime = minDT.toISOString();

      this.getData();
    }
  };
</script>
<style>

  .chart-area {
    height: auto !important;
  }

  .datetime-input {
    margin-left: 10px;
    font-weight: bold;
    width: 160px;
    padding-left: 5px;
    height: 22px;
    font-size: 17px;
  }

  .btn-custom {
    margin-right: 10px;
  }
</style>
